import { IBandUserSelectOption } from "Bands/containers/PeoplePicker/useLogic";
import { IBand } from "Bands/types";
import { ChangeEvent } from "react";

import { copy } from "shared/assets";
import { Band } from "shared/assets/icons";
import { API_ENDPOINTS } from "shared/constants";
import { space } from "shared/styles/constants";
import { IFieldType, IFormFields, IFormWidgetType } from "shared/types";

const fieldsCopy = copy.venueBlock.createVenue.fields;

export interface VenueExtraFormFieldsProps {
  currentBandId: string;
  currentUserId?: string;
  bands: IBand[];
  handleBandsChange: (bandIds: string[] | null) => void;
  handleNotifyChange: (notify: boolean) => void;
  handleUsersChange: (users: string[] | null) => void;
}

export const getFields = ({
  currentBandId,
  currentUserId,
  bands,
  handleBandsChange,
  handleNotifyChange,
  handleUsersChange,
}: VenueExtraFormFieldsProps): IFormFields => [
  {
    name: "bandsTitle",
    widget: IFormWidgetType.title,
    label: fieldsCopy.bandsTitle,
    style: {
      marginTop: space.s,
    },
  },
  {
    type: IFieldType.checkboxGroup,
    name: "bands",
    label: fieldsCopy.bands,
    options: bands.map(({ id, title }) => ({
      value: id,
      label: title,
      disabled: id === currentBandId,
      icon: Band,
    })),
    onChange: (value: string[]) => {
      handleBandsChange(
        value ? value.map((id) => API_ENDPOINTS.BAND(id)) : null
      );
    },
  },
  {
    name: "editTitle",
    widget: IFormWidgetType.title,
    label: fieldsCopy.editTitle,
    style: {
      marginTop: space.s,
    },
  },
  {
    name: "users",
    label: "",
    type: IFieldType.peoplePicker,
    settings: {
      includeUsersFromAllBands: true,
      hideCategories: true,
      excludeOptions: [currentUserId || ""],
    },
    onChange: (value: IBandUserSelectOption[]) => {
      handleUsersChange(
        value ? value.map(({ value }) => API_ENDPOINTS.BAND_USER(value)) : []
      );
    },
  },
  {
    name: "notifyTitle",
    widget: IFormWidgetType.title,
    label: fieldsCopy.notifyTitle,
    style: {
      marginTop: space.s,
    },
  },
  {
    type: IFieldType.checkbox,
    name: "notify",
    label: fieldsCopy.notify,
    onChange: (event: ChangeEvent<HTMLInputElement>) => {
      handleNotifyChange(event.target.checked);
    },
  },
];
